import { shortMonthAndYear } from "@similarweb/pro-logic-components";
import { EmptyState } from "@similarweb/ui-components";
import { Flex } from "@similarweb/ui-components/foundations";

import { WidgetContainer } from "app/components/React/WidgetContainer/WidgetContainer";
import DurationService, { BasicDurations } from "app/services/DurationService";
import { useTranslation } from "pro-features/components/WithTranslation";

export const MarketDifficultyComparisonWidget = () => {
    const t = useTranslation();

    const subtitleDate = DurationService.getDurationData(BasicDurations.LAST_MONTH).forAPI.to;
    const subtitleFilters = [
        {
            filter: "date",
            value: {
                to: subtitleDate,
                format: shortMonthAndYear,
            },
        },
    ];

    return (
        <WidgetContainer
            withBorder
            height="400px"
            bodyHeight="310px"
            subtitleFilters={subtitleFilters}
            title={t("industryoverview.market.difficulty.header.title")}
            tooltip={t("industryoverview.market.difficulty.title.tooltip")}
            automationId="industry-analysis-overview-comparison-market-difficulty"
        >
            <Flex
                justifyContent="center"
                alignItems="center"
                height="100%"
            >
                <EmptyState
                    title={t("industryoverview.market.difficulty.comparison.empty.title")}
                    subtitle={t("industryoverview.market.difficulty.comparison.empty.subtitle")}
                />
            </Flex>
        </WidgetContainer>
    );
};
